/* import __COLOCATED_TEMPLATE__ from './mass-start-timing-classgroup-association-table.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { inject as service } from '@ember/service';
import dayjs from 'dayjs';

export default class MassStartTimingClassGroupAssociationTableComponent extends Component 
{
	@service store;
	@service ajax;
	
	@tracked selectedClassGroup = null;
	
	get clearDisabled()
	{
		return this.args.selectedStartImpulse == null;
	}
	get associateDisabled()
	{
		return this.args.selectedStartImpulse == null;
	}
	
	@action
	classGroupSelectionChanged(browserEvent)
	{
		var classGroup = browserEvent.target.value;
		
		if(classGroup == '-')
		{
			this.selectedClassGroup = null;
		}
		else
		{
			var foundClassGroup = this.store.peekRecord('classGroup', classGroup);
			this.selectedClassGroup = foundClassGroup;
		}
	}
	
	@action
	clear()
	{
		this.args.startImpulseSelectAction(null);
	}
	
	@action
	async associateWithEveryClassGroupEntry()
	{
		let classGroup = this.selectedClassGroup;
		let sSTR = this.args.selectedStartImpulse;
		
		if(classGroup == null)
		{
			alert("no class group selected");
			return;
		}
		if(sSTR == null)
		{
			alert("no start impulse selected");
			return;
		}
		
		const response = await this.ajax.request("/class-groups/"+classGroup.id+"/associateAllWithStartTimingRecord/"+sSTR.id);
		
		if(response.error != null)
			alert(response.error);
		
		this.clear();
	}
	
	@action
	async associateWithUnassignedClassGroupEntries()
	{
		let classGroup = this.selectedClassGroup;
		let sSTR = this.args.selectedStartImpulse;
		
		if(classGroup == null)
		{
			alert("no class group selected");
			return;
		}
		if(sSTR == null)
		{
			alert("no start impulse selected");
			return;
		}
		
		const response = await this.ajax.request("/class-groups/"+classGroup.id+"/associateUnassignedWithStartTimingRecord/"+sSTR.id);
		
		if(response.error != null)
			alert(response.error);
		
		this.clear();
	}
	
	@action
	async associateWithFirstLegEntries()
	{
		let classGroup = this.selectedClassGroup;
		let sSTR = this.args.selectedStartImpulse;
		
		if(classGroup == null)
		{
			alert("no class group selected");
			return;
		}
		if(sSTR == null)
		{
			alert("no start impulse selected");
			return;
		}
		
		const response = await this.ajax.request("/class-groups/"+classGroup.id+"/associateFirstLegsWithStartTimingRecord/"+sSTR.id);
		
		if(response.error != null)
			alert(response.error);
		
		this.clear();
	}
}
